module.exports = __webpack_public_path__ + "static/podcastMicrophone-de458e66fa73f14644c6c90be8f65fe7.svg";